import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { Webinars } from "../../src/landingPage/views/Webinars/Webinars";
import butter from "../../src/landingPage/utils/butter-client";

const WebinarsPage = ({ data }) => {
  return (
    <>
      <NextHead
        currentPath="/webinars"
        title={`Demyst Webinar Series`}
        description="Demyst's weekly on-demand webinars discuss points of interest in the ecosystem of external data with industry experts. Watch now!"
      />
      <Webinars data={data} />
    </>
  );
};

export const getServerSideProps = async () => {
  try {
    const response = await butter.page.retrieve("*", "webinars");
    const data = response.data.data.fields;
    return {
      props: {
        data,
        wrapper: "MarketingWrapper",
      },
    };
  } catch (e) {
    return {
      notFound: true,
    };
  }
};

export default WebinarsPage;
